import { useMemo } from 'react';
import { useImmer } from 'use-immer';
import {
  IPercentileFilterInput,
  Maybe,
  RelationalOperatorKey,
} from '../../../../../utils/apollo/graphqlSchema';

interface IPercentileFormState {
  operator: RelationalOperatorKey;
  operand: number | null;
  fromOperand: number | null;
  toOperand: number | null;
  pristine: boolean;
}

const initialState: IPercentileFormState = {
  operator: RelationalOperatorKey.Greaterorequal,
  operand: 90,
  fromOperand: null,
  toOperand: null,
  pristine: true,
};

export default (defaultState: Maybe<IPercentileFilterInput>) => {
  const [state, setState] = useImmer<IPercentileFormState>(() => {
    if (!defaultState) {
      return initialState;
    }

    const operator = defaultState.operator;

    if (operator === RelationalOperatorKey.Between) {
      return {
        operator,
        operand: null,
        fromOperand: defaultState.values[0],
        toOperand: defaultState.values[1],
        pristine: true,
      };
    }

    return {
      operator,
      operand: defaultState.values[0],
      fromOperand: null,
      toOperand: null,
      pristine: true,
    };
  });

  const actions = useMemo(
    () => ({
      changeOperatorKey: (value: string) => {
        if (value === RelationalOperatorKey.Between) {
          setState(() => {
            return {
              ...initialState,
              operator: value as RelationalOperatorKey,
              pristine: false,
            };
          });

          return;
        }

        setState((draft) => {
          draft.operator = value as RelationalOperatorKey;
          draft.pristine = false;
        });
      },
      changeOperand: (value: number | null) =>
        setState((draft) => {
          draft.operand = value;
          draft.pristine = false;
        }),
      changeFromOperand: (value: number | null) =>
        setState((draft) => {
          draft.fromOperand = value;
          draft.pristine = false;
        }),
      changeToOperand: (value: number | null) =>
        setState((draft) => {
          draft.toOperand = value;
          draft.pristine = false;
        }),
      reset: () =>
        setState(() => {
          return initialState;
        }),
    }),
    [setState],
  );

  return {
    state,
    actions,
  };
};
